import { RESET_FORM } from '../actionTypes';
import { createAccountActions } from '../reducer';

export default () => createAccountActions[RESET_FORM]();
